import React from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import cs from 'classnames';

import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import { Flex } from 'shared/components/display';

import spotlightIcon from 'shared/images/icons/spotlight-creator-badge.svg';

import styles from './styles';

interface Props {
  className?: string;
  size?: SizeProp;
  showTooltip?: boolean;
  showHoverBox?: boolean;
}
const SpotlightCreatorBadge: React.FC<Props> = ({
  className,
  size = 'lg',
  showTooltip = false,
  showHoverBox = false,
}) => {
  return (
    <Tooltip content="Spotlighted Creator: A rising star at brkfst.io" disabled={!showTooltip}>
      <Flex
        css={styles}
        className={cs('spotlight-creator-badge', {
          'spotlight-creator-badge--hover': showHoverBox,
        })}
        dataCy="spotlight-creator-badge"
      >
        <img src={spotlightIcon} className="spotlight-creator-badge__icon" />
      </Flex>
    </Tooltip>
  );
};

export default SpotlightCreatorBadge;
